
import { useStore } from '@/store'
import { defineComponent, ref, watch } from 'vue'
import { computed } from 'vue'
import GreenboardOption from '@/components/Form/GreenboardOption.vue'
import bagsizeSettings from '@/settings/bagsize-settings.json'
import bodySettings from '@/settings/body-settings.json'
import edgeSettings from '@/settings/edge-settings.json'
import threadSettings from '@/settings/thread-settings.json'
import insideSettings from '@/settings/inside-settings.json'
import pocketSettings from '@/settings/pocket-settings.json'
import sideSettings from '@/settings/side-settings.json'
import frontSettings from '@/settings/front-settings.json'
import tackSettings from '@/settings/tack-settings.json'
import backSettings from '@/settings/back-settings.json'
import nameSettings from '@/settings/name-settings.json'
import NameConverterService from '@/services/form/name-converter.service'
import SentrySingleton from '@/singletons/sentry-singleton'

export default defineComponent({
  name: 'Greenboard',
  components: {
    GreenboardOption
  },
  setup() {
    const store = useStore()
    const configBagsizeId = computed(() => store.getters.configBagsizeId)
    const configBodyId = computed(() => store.getters.configBodyId)
    const configEdgeId = computed(() => store.getters.configEdgeId)
    const configThreadId = computed(() => store.getters.configThreadId)
    const configInsideId = computed(() => store.getters.configInsideId)
    const configPocketId = computed(() => store.getters.configPocketId)
    const configSideId = computed(() => store.getters.configSideId)
    const configFrontId = computed(() => store.getters.configFrontId)
    const configTackId = computed(() => store.getters.configTackId)
    const configBackId = computed(() => store.getters.configBackId)
    const configNonameId = computed(() => store.getters.configNonameId)
    const configNamechar = computed(() => store.getters.configNamechar)
    const configNamethreadId = computed(() => store.getters.configNamethreadId)
    const configLoaded = computed(() => store.getters.configLoaded)
    const root = ref(null)
    let bagsize = ref()
    let body = ref()
    let edge = ref()
    let thread = ref()
    let inside = ref()
    let pocket = ref()
    let side = ref()
    let front = ref()
    let tack = ref()
    let back = ref()
    let nameText = ref()
    let nameColor = ref()
    let nameConverterService = new NameConverterService()

    // prettier-ignore
    watch(() => root.value, (_) => {
        if (root.value) {
          fill()
        }
      }
    )

    // prettier-ignore
    watch(() => configLoaded.value, (tab) => {
      fill()
    })

    function fill() {
      try {
        bagsize.value = formatConfig(bagsizeSettings.bagsizeOptions.find((obj) => obj.id == configBagsizeId.value))
        body.value = formatConfig(bodySettings.fullorderColors.find((obj) => obj.id == configBodyId.value))
        edge.value = formatConfig(edgeSettings.edgeColors.find((obj) => obj.id == configEdgeId.value))
        thread.value = formatConfig(threadSettings.threadColors.find((obj) => obj.id == configThreadId.value))
        inside.value = formatConfig(insideSettings.futaNoUraTextures.find((obj) => obj.id == configInsideId.value))
        pocket.value = formatConfig(pocketSettings.pocketTextures.find((obj) => obj.id == configPocketId.value))
        side.value = formatConfig(sideSettings.sideTextures.find((obj) => obj.id == configSideId.value))
        front.value = formatConfig(frontSettings.futaShapeTextures.find((obj) => obj.id == configFrontId.value))
        tack.value = formatConfig(tackSettings.options.find((obj) => obj.id == configTackId.value))
        back.value = formatConfig(backSettings.backColors.find((obj) => obj.id == configBackId.value))
        nameText.value = formatNameChar(configNamechar.value)
        nameColor.value = formatNameColor(nameSettings.nameitoColors.find((obj) => obj.id == configNamethreadId.value))
      } catch (err) {
        SentrySingleton.instance.captureException(err)
      }
    }

    function formatConfig(obj: any) {
      return obj ? obj.name : null
    }

    function formatNameChar(str) {
      if (isNoName()) {
        return 'いれない'
      }
      if (!str || 0 === str.length) {
        return ''
      }
      return nameConverterService.convertToHTMLCharacters(str)
    }

    function formatNameColor(obj: any) {
      if (isNoName()) {
        return 'なし'
      }
      return obj ? obj.name : null
    }

    function isNoName(): boolean {
      return configNonameId.value == nameSettings.noName.id
    }

    const getSmallLatterSpacing = () => {
      return configBagsizeId.value == bagsizeSettings.bagsizeOptions[1].id
    }

    return {
      root,
      bagsize,
      body,
      edge,
      thread,
      inside,
      pocket,
      side,
      front,
      tack,
      back,
      nameText,
      nameColor,
      getSmallLatterSpacing
    }
  }
})
